import invokeApi from '#/utils/invokeApi'

export function getProperties(
  attomids: string[],
  abortController?: AbortController
) {
  return invokeApi<{ items: TopHap.ExtendedProperty[] }>({
    endpoint: '/v4/properties',
    method: 'POST',
    body: { attomids },
    abortController
  })
}
